import styled from "styled-components";


export const Container = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.8rem 10rem;
  
  background-color: #21212150;
  
  backdrop-filter: blur(6px);

  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 1000;

  img {
    height: 32px;
  }

  nav{
    display: flex;
    align-items: center;
    gap: 1.8rem;
    a, button{
      color: #FFFF;
      padding: 0.6rem;
      font-family: 'Red Hat Display', sans-serif;
      font-weight: 500;
      text-transform: uppercase;
      transition: filter 0.25s;
      border: none;
      background: transparent;
      cursor: pointer;
      text-decoration: none;

      &.button{
        padding: 0.6rem 5rem;
        background-color: var(--green);
        border-radius: 0.5rem;
      }

      &:hover{
        filter: brightness(0.6);
      }
    }

    .button.button-pdf{
      margin-left: 10px;
      width: 160px;
      padding: 5px 0;
    }

    .game-highlight{
      position: relative;
      border-radius: 0.5rem;
      animation: game-pulse 1.8s ease-in-out infinite;

      &:hover{
        animation-play-state: paused;
      }
    }

    .lang-switch{
      background: transparent;
      width: 40px;
      border: 1px solid var(--green);
      color: #fff;
      border-radius: 0.6rem;
      padding: 0.4rem 0.8rem;
      font-weight: 700;
      letter-spacing: 0.05em;
      transition: filter 0.25s, transform 0.2s;
      &:hover{ filter: brightness(1.1); transform: translateY(-1px); }
      &:active{ transform: translateY(0); }
    }

  }

  @keyframes game-pulse {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(35, 206, 107, 0.55);
    }
    50% {
      box-shadow: 0 0 0 8px rgba(35, 206, 107, 0);
    }
  }

  /* when light theme is active, make the lang-switch text dark to match other menu items */
  html.light & {
    .lang-switch {
      color: #121212;
    }
  }


  .menu-container{
    cursor: pointer;
    padding: 0.6rem 0;
  }

  .menu{
    width: 2rem;
    height: 0.2rem;
    background: #FFFF;
    border: none;
    border-radius: 0;
    padding: 0;
    position: relative;
    cursor: pointer;
    display: none;

    &:before{
      bottom: 0.5rem;
    }
    &:after{
      top: 0.5rem;
    }


    &.active:before{
      bottom: 0;
      transform: rotate(45deg);
    }

    &.active:after{
      top: 0;
      transform: rotate(135deg);
    }

    &.active{
      background-color: rgba(0, 0, 0, 0);
    }

  }

  .menu:before, .menu:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 0.2rem;
    background: #FFFF;
    cursor: pointer;
    transition: .6s;
  }


  input[type=checkbox] {
    height: 0;
    width: 0;
    visibility: hidden;
    outline: none;
  }

  label {
    cursor: pointer;
    text-indent: -9999px;
    width: 55px;
    height: 30px;
    background: var(--green);
    display: block;
    justify-content: center;
    align-items: center;
    -webkit-border-radius: 100px;
    -moz-border-radius: 100px;
    border-radius: 100px;
    position: relative;
    margin-left: auto;
    right: 10px;
  }

  @media only screen and (max-width: 800px) {
    label {
    position: relative;
   }
  }

  label:after {
    content: '';
    background: #FFF;
    width: 20px;
    height: 20px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    position: absolute;
    top: 5px;
    left: 4px;
   transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  }

  input:checked + label {
    background: var(--pink);
  }

  input:checked + label:after {
    left: calc(100% - 5px);
    -webkit-transform: translateX(-100%);
    -moz-transform: translateX(-100%);
    -ms-transform: translateX(-100%);
    -o-transform: translateX(-100%);
    transform: translateX(-100%);
  }

  @media (max-width: 960px){
    padding: 1.8rem 3rem;

    .menu{
      display: block;
    }

    nav {
      -ms-overflow-style: none;
      scrollbar-width: none;
      overflow: hidden;
      opacity: 0;
      visibility: hidden;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: fixed;
      width: 100vw;
      height: 100vh;
      background: var(--blue);
      top: 0;
      left: 0;
      transition: opacity 0.25s;
      background-color: var(--green);

      a.button, button.button{
        background-color: var(--pink);
      }

      &.active{
        opacity: 1;
        visibility: visible;
      }
    }
  }
  
`